import { CommonMessage } from '@frontend/lang';
import { User } from '@frontend/user/utils';
import { LuX } from 'react-icons/lu';
import { Link } from 'react-router-dom';

import useMobileNavbar from './mobile-navbar.controller';

export interface MobileNavbarProps {
    open: boolean;
    onClose: () => void;
}

function MobileNavbar({ open, onClose }: MobileNavbarProps) {
    const viewProps = useMobileNavbar();
    if (!open) return null;

    return (
        <div className='bg-background-surface animate-fade-in fixed inset-0 z-[100] flex flex-col md:hidden'>
            <div className='border-border-default flex h-20 items-center justify-between border-b px-6'>
                <span className='text-xl font-medium'>Menu</span>
                <button
                    onClick={onClose}
                    aria-label='Close menu'>
                    <LuX className='size-6' />
                </button>
            </div>
            <div
                className='border-border-default hover:bg-background-default flex cursor-pointer items-center gap-2 border-b px-6 py-5 transition-colors'
                onClick={() => (window.location.href = '/profile')}>
                <div className='bg-brand-structure text-background-surface flex size-10 items-center justify-center rounded-full text-lg font-medium'>
                    {viewProps.user ? `${(viewProps.user.first_name?.[0] ?? '').toUpperCase()}${(viewProps.user.last_name?.[0] ?? '').toUpperCase()}` : 'U'}
                </div>
                <div className='flex flex-col'>
                    <span className='text-foreground-default text-base font-semibold'>
                        {viewProps.user ? new User(viewProps.user).getDisplayName() : CommonMessage.OBJECTS.USER.DEFAULT}
                    </span>
                    <span className='text-brand-muted text-xs font-medium'>{viewProps.user?.unique_identifier}</span>
                </div>
            </div>
            <nav className='flex flex-1 flex-col overflow-y-auto px-6 py-4'>
                {viewProps.links.map((link) => (
                    <Link
                        key={link.href}
                        to={link.href}
                        state={link.state}
                        className='text-foreground-default flex h-12 items-center gap-3 text-lg font-medium'>
                        {link.icon && <span className='text-xl'>{link.icon}</span>}
                        {link.label}
                    </Link>
                ))}
            </nav>
        </div>
    );
}

export default MobileNavbar;
